module.exports = __webpack_public_path__ + "js/0.79c31149.worker.js"